<p-dialog [modal]="true" [(visible)]="isVisible">
    <p-header><span *ngIf="header =='Advertiser' || header == 'Meta Ad Account'" >External </span> {{header}}</p-header>

    <div class="col mx-4 d-flex align-items-center font-weight-bold" *ngIf="header =='Advertiser' || header == 'Meta Ad Account'">
        <label class="align-items-center" style="margin-left: 180px;">API Created</label>
        <label class="align-items-center" style="margin-left: 140px;">Override</label>
    </div>
    
    <!-- <ng-template> -->
    <div *ngIf="header != 'Meta Ad Account' && (campaignType == enumAccountType.FAN365 || campaignType == enumAccountType.OAS || campaignType == enumAccountType.HS || campaignType == enumAccountType.HMP  || header!='Advertiser')" class="mb-2 mt-4 row align-items-center">

        <div class="col font-weight-bold">
            {{header =='Advertiser'? (campaignType == enumAccountType.FAN365 || campaignType == enumAccountType.OAS || campaignType == enumAccountType.HS || campaignType == enumAccountType.HMP  ? 'GCM Advertiser ID' : 'Advertiser ID' ) : 'Landing Page Url'}}
        </div>
        <div class="col">
            <input *ngIf="header!='Advertiser'" type="text" [(ngModel)]="landingPageUrl" (ngModelChange)="validateLandingPage()" pInputText>
            <input *ngIf="header =='Advertiser'" type="number"  [(ngModel)]="advertiserId" readonly pInputText>
        </div>
        <div class="col">
            <input *ngIf="header =='Advertiser'" type="number" (change)="onChangeGCMAdvertiserId()" [(ngModel)]="overrideGCMAdvertiserId" pInputText>
        </div>
    </div>
    <!-- <span *ngIf="campaignType != enumAccountType.FAN365 && campaignType != enumAccountType.OAS && campaignType != enumAccountType.Social && header =='Advertiser'">
        <div class="mb-2 row align-items-center">
            <div class="col-md-5 font-weight-bold">
                Advertiser Name
            </div>
            <div class="col-md-6">
                <input type="text" [(ngModel)]="advertiserName" pInputText>
            </div>
        </div>
    </span> -->
    <div *ngIf="header =='Advertiser' && (campaignType == enumAccountType.FAN365 || campaignType == enumAccountType.HS || campaignType == enumAccountType.HMP)" class="mb-2 mt-3 row align-items-center">
        <div class="col font-weight-bold">
            TTD Advertiser ID
        </div>
        <div class="col">
            <input type="text" [(ngModel)]="ttdadvertiserId" readonly pInputText>
        </div>
        <div class="col">
            <input type="text" (change)="onChangeTTDAdvertiserId()" [(ngModel)]="overrideTTDAdvertiserId" pInputText>
        </div>
    </div>
    <div *ngIf="header =='Advertiser' && (campaignType == enumAccountType.FAN365 || campaignType == enumAccountType.HS || campaignType == enumAccountType.HMP)" class="mb-2 mt-3 row align-items-center">
        <div class="col font-weight-bold">
            DV360 Advertiser ID
        </div>
        <div class="col">
            <input type="text" [(ngModel)]="dv360advertiserId" readonly pInputText>
        </div>
        <div class="col">
            <input type="text" (change)="onChangeDV360AdvertiserId()" [(ngModel)]="overrideDV360AdvertiserId" pInputText>
        </div>
    </div>
    <div *ngIf="header =='Advertiser' && campaignType == enumAccountType.OAS" class="mb-2 mt-4 row align-items-center">
        <div class="col font-weight-bold">
            GAM Advertiser ID
        </div>
        <div class="col">
            <input type="text" [(ngModel)]="gamadvertiserId" readonly pInputText>
        </div>
        <div class="col">
            <input type="text" (change)="onChangeGAMAdvertiserId()" [(ngModel)]="overrideGAMAdvertiserId" pInputText>
        </div>
    </div>
    <div *ngIf="(header =='Advertiser' || header =='Meta Ad Account') && campaignType != enumAccountType.OAS" class="mb-2 mt-3 row align-items-center">
        <div class="col font-weight-bold required">
            Meta Ad Account ID
        </div>
        <div class="col">
            <input type="text" [(ngModel)]="metaAdAccountId" readonly pInputText>
        </div>
        <div class="col">
            <input type="text" [(ngModel)]="overrideMetaAdAccountId" (ngModelChange)="validateAdAccountId(); onChangeMetaAdAccountId()" pInputText>
        </div>
    </div>
    <div *ngIf="(header =='Advertiser' || header =='Meta Ad Account') && campaignType != enumAccountType.OAS" class="mb-2 mt-3 row align-items-center">
        <div class="col font-weight-bold required">
            Meta Ad Account Name
        </div>
        <div class="col">
            <input type="text" [(ngModel)]="metaAdAccountName" readonly pInputText>
        </div>
        <div class="col">
            <input type="text" (change)="onChangeMetaAdAccountName()" [(ngModel)]="overrideMetaAdAccountName" pInputText>
        </div>
    </div>
 	<div *ngIf="header =='Advertiser' || header == 'Meta Ad Account' && (campaignType == enumAccountType.FAN365 || campaignType == enumAccountType.OAS || campaignType == enumAccountType.HS || campaignType == enumAccountType.HMP)" class="mb-2 mt-4 row align-items-center" style="padding: 12px;">
        <button *ngIf="header != 'Meta Ad Account'" pButton class="px-3 p-button-primary"  label="Create Missing Advertisers" (click)="createAdvertiser()" >
        </button>
        <img *ngIf="isLoading" src="https://media.tenor.com/LeDb4HArelwAAAAi/loading-betterttv.gif" class="spinner" alt="Loading..." style="width: 20px; height: 20px; margin-left: 8px;" />
    </div>
    <div *ngIf="!canSave" class=" col-md-12 mb-2 mt-2 row ml-0 invalid-message-box d-flex align-items-center edge-border" style="min-height: 3em;">
        <span class="pl-3">Please enter a valid landing page.</span>
    </div>

    <div *ngIf="header =='Advertiser' || header == 'Meta Ad Account'" class="mb-3 alert alert-warning text-center edge-border" style="min-height: 3em;">
        By changing Advertisers you are changing them only for this campaign.
    </div>


    <!-- </ng-template> -->


    <p-footer>
        <div class="mb-3">
            <button (click)="cancel()" pButton class="px-3 edge-flat-btn" label="Cancel"></button>
            <button (click)="save()" pButton class="px-3 p-button-primary edge-button" [disabled]='!canSave || (!!overrideMetaAdAccountId && !isAdAccountIdValid)' [attr.title]="(!!overrideMetaAdAccountId && !isAdAccountIdValid) ? 'Please enter a valid Meta Ad Account ID.' : ''"label="Save"></button>
        </div>
    </p-footer>
</p-dialog>